<template>
  <div>
    <v-dialog v-model="show" persistent fullscreen>
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <action-button type="close" :icon_only="true" @click="cancel" small />
        </v-card-title>
        <v-card-text class="py-0">
          <v-stepper v-model="currentStep">
            <v-stepper-header>
              <template v-for="(n, i) in groups">
                <v-stepper-step :key="`${i + 1}-step`" :complete="currentStep > i + 1" :step="i + 1">
                  <span v-if="n.company_id">{{ `(${n.company_vat}) ${n.company_name}` }}</span>
                  <span v-if="n.companies.length >= 2">{{ `${n.participants[0].first_name} ${n.participants[0].last_name} (${$t('enrolments.multiple_companies')})` }}</span>
                  <span v-if="!n.company_id && n.companies.length == 0"> {{ `${n.participants[0].first_name} ${n.participants[0].last_name}` }}</span>
                </v-stepper-step>
                <v-divider v-if="i + 1 !== groups.length" :key="i + '-step-key'"></v-divider>
              </template>
            </v-stepper-header>

            <v-stepper-items>
              <v-stepper-content v-for="(n, i) in groups" :key="`${i + 1}-content`" :step="i + 1">
                <v-card>
                  <enrolment-company-form
                    v-if="i + 1 == currentStep && n.companies && n.type == 'multiple'"
                    :locale="$getSetting('locale')"
                    :cid="course_uuid"
                    :autofill_data="n"
                    :modal="true"
                    @return_modal_form="return_modal_form"
                  />

                  <enrolment-company-form
                    v-if="i + 1 == currentStep && n.company_id && n.type == 'company'"
                    :locale="$getSetting('locale')"
                    :cid="course_uuid"
                    :autofill_data="n"
                    :modal="true"
                    @return_modal_form="return_modal_form"
                  />

                  <enrolment-personal-form
                    v-if="i + 1 == currentStep && !n.company_id && n.type == 'personal'"
                    :locale="$getSetting('locale')"
                    :cid="course_uuid"
                    :autofill_data="n"
                    :modal="true"
                    @return_modal_form="return_modal_form"
                  />
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "MultiEnrolmentFomPopup",

  components: {
    "enrolment-personal-form": () => import("@/modules/frontend/components/EnrolmentPersonal.vue"),
    "enrolment-company-form": () => import("@/modules/frontend/components/EnrolmentOrganisation.vue")
  },

  props: {
    show: {
      type: Boolean,
      required: true
    },
    course_id: {},
    course_uuid: {
      type: String
    },
    autofill_data: {
      type: Object
    }
  },

  data() {
    return {
      groups: [],
      participants: [],

      enrolment_ids: [],

      currentStep: 1
    }
  },

  watch: {
    show: {
      handler(val) {
        if (val) {
          this.init()
        }
      }
    }
  },

  mounted() {},

  methods: {
    init() {
      let vm = this
      this.participants = this.autofill_data.participants

      if (this.participants.length > 0) {
        this.participants.forEach((i) => {
          let companies = i.companies

          if (companies && companies.length >= 1) {
            if (companies.length >= 2) {
              if (!vm.groups.find((g) => g.participants.find((h) => h.id == i.id) && g.type == "multiple")) {
                vm.groups.push({
                  type: "multiple",
                  companies: companies,
                  company_id: null,
                  company_name: null,
                  company_vat: null,
                  participants: [i]
                })
              }
            } else {
              let company = companies[0]

              if (!vm.groups.find((g) => g.company_id == company.id)) {
                vm.groups.push({
                  type: "company",
                  companies: [],
                  company_id: company.id,
                  company_name: company.name,
                  company_vat: company.vat,
                  participants: []
                })
              }

              let g = vm.groups.find((g) => g.company_id == company.id && g.type == "company")
              if (g && !g.participants.find((p) => p.id == i.id)) {
                g.participants.push(i)
              }
            }
          } else {
            vm.groups.push({
              type: "personal",
              companies: [],
              company_id: null,
              company_name: null,
              company_vat: null,
              participants: [i]
            })
          }
        })
      }

      console.log(this.groups)
    },

    cancel() {
      this.$emit("callback_multienrpopup_cancel")
    },

    return_modal_form(data) {
      if (data) {
        if (this.currentStep == this.groups.length) {
          this.$emit("callback_multienrpopup_submit", null)
        } else {
          this.currentStep += 1
        }

        if (data != "cancel") {
          this.$emit("callback_multienrpopup_submit", data)
        }
      }
    }
  }
}
</script>

<style scoped></style>
